<p-confirmDialog [key]="key" [header]="header" [icon]="icon" [width]="width" acceptLabel="Sim" rejectLabel="Não" appendTo="body"
  acceptButtonStyleClass="btn btn-size btn-primary" rejectButtonStyleClass="btn btn-size btn-danger">
</p-confirmDialog>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵf.html